export enum ConfirmModals {
  Completed = 'completed_modal',
  Delete = 'delete_modal',
  DeleteReports = 'delete_reports_modal',
  DeleteSelected = 'delete_selected_modal',
  Clone = 'clone_modal',
  Create = 'create_schedule_deliverable_modal',
  Edit = 'edit_schedule_deliverable_modal',
  Email = 'send_email_modal',
  Logs = 'logs_modal',
}
